import React, { CSSProperties, FC } from 'react';
import { Button, Space } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { SearchOutlined } from '@ant-design/icons/lib';
import styled from 'styled-components';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';
import { PartnerStatusSelect } from 'common/components/StatusSelect';

const StyledSpace = styled(Space)`
  flex-wrap: wrap;
  > * {
    margin-bottom: 0.5rem;
    flex-grow: 1;
    flex-shrink: 1;
    max-width: 200px;
  }
`;

const StyledForm = styled(Form)`
  max-width: 100%;
`;

export interface ProfileOwnerFiltersFormModel {
  active?: string | boolean;
  name?: string;
  identifier?: number;
  status?: string;
}

export interface ProfileOwnerFiltersProps {
  loading?: boolean;
  value?: ProfileOwnerFiltersFormModel;
  onSubmit: FormikOnSubmit<ProfileOwnerFiltersFormModel>;
  style?: CSSProperties;
}

export const BusinessPartnersSubpartnersFilters: FC<ProfileOwnerFiltersProps> = ({
  onSubmit,
  loading,
  value = {},
  style,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik initialValues={value} onSubmit={onSubmit} onReset={onSubmit}>
      <StyledForm style={style} layout="inline">
        <StyledSpace>
          <Input
            name="name"
            placeholder={intlMessage({ id: 'name' })}
            style={{ minWidth: 150 }}
          />
          <Input
            name="description"
            placeholder={intlMessage({ id: 'identifier' })}
            style={{ minWidth: 150 }}
          />
          <PartnerStatusSelect
            name="active"
            placeholder={intlMessage({ id: 'status' })}
            style={{ minWidth: 200, width: '100%' }}
          />
          <Space>
            <SubmitButton
              type="default"
              loading={loading}
              icon={<SearchOutlined />}
            >
              <FormattedMessage id="search" tagName="span" />
            </SubmitButton>
            <Button id="button-clear-subpartners-filter" htmlType="reset">
              <FormattedMessage id="clear" />
            </Button>
          </Space>
        </StyledSpace>
      </StyledForm>
    </Formik>
  );
};
